import i18n from "translation";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CountriesState, getCountries } from "explorer/reducers/countries";
import { GenresState, getGeneros } from "explorer/reducers/generos";
import { setCountryOptionsI18n } from "explorer/reducers/countries";
import { setGenreOptionsI18n } from "explorer/reducers/generos";

export default function useI18nOptions() {
  const dispatch = useDispatch();
  const { countries } = useSelector((state: CountriesState) => state.countries);
  const { genres } = useSelector((state: GenresState) => state.genres);

  useEffect(() => {
    if (countries) {
      dispatch(setCountryOptionsI18n(i18n.language));
    }
    if (genres) {
      dispatch(setGenreOptionsI18n(i18n.language));
    }
  }, [dispatch, countries, genres]);

  useEffect(() => {
    dispatch(getCountries());
    dispatch(getGeneros());
  }, [dispatch]);
}
